export default "__VITE_ASSET__Bs7SSi1e__"